<template>
  <div class="serieses">
    <div class="loading" v-if="seriesesFilesLoading">資料載入中...</div>
    <div class="row series no-gutters"
      :id="`series${series.id}`"
      :name="`series${series.id}`"
      v-if="seriesesFilesLoading == false"
      v-for="series in serieses" :key="series.id"
      :class="getAttribute(series, 'css_class')"
      v-init="seriesColumnCount = getAttribute(series, 'column', 3)"
      >
      <div class="col-12 col-md-12" :class="`series-${series.prefix}-title`">
        <div class="sprite d-flex justify-content-center"
          :class="[`${getAttribute(series, 'css_class_title')}`]"
          v-if="getAttribute(series, 'css_class_title') != ''">
          <div v-html="series.title" class="title"></div>
          <img v-if="false" :src="sprite_image_src" :class="getAttribute(series, 'css_class_title')" />
        </div>
        <p v-html="series.title" v-if="getAttribute(series, 'css_class_title') == ''" class="title"></p>
        <p v-html="getAttribute(series, 'title-2')" v-if="getAttribute(series, 'title-2') != ''" class="title-2"></p>
        <p v-html="series['sub-title']" class="sub-title"></p>
        <div class="thumbs row justify-content-around"
          :class="`series-${series.prefix}`">
          <div class="col-10 col-sm-10 course"
            :class="{
              'col-md-3': seriesColumnCount == 3,
              'col-lg-4': seriesColumnCount == 3,
              'col-md-6': seriesColumnCount == 2,
              'col-lg-6': seriesColumnCount == 2,
            }"
            v-for="index in createIndexArray(seriesColumnCount)" :key="index"
            v-init="_course = getCourseByIndexInSeries(series, index)"
            >
            <div class="row cover-row">
              <div class="col">
                <div class="cover d-flex justify-content-center"
                  :class="[
                    getAttribute(_course, 'cover') !== '' ? 'playable' : '',
                    checkIsPlaying(series.prefix, index) && is_playing ? 'playing': '',
                    checkIsHover(series.prefix, index) ? 'hover': '',
                    `series-${series.prefix}-${index}`
                  ]"
                  v-bind:play="getAttribute(_course, 'cover')"
                  @click="playVideo(series, getCourseByIndexInSeries(series, index))"
                  :ref="`cover-player-${series.prefix}-${index}`"
                  >
                  <div class="item-background"
                    :class="getAttribute(_course, 'custom-thumb-background-css')">
                    <img class="item"
                      v-if="getAttribute(_course, 'custom-thumb-video') == ''"
                      :src="getCourseImageSrcMore(`${getAttribute(_course, 'custom-thumb', `images_${series.prefix}0${index}.jpg`)}`)" />
                    <video-player
                        class="video-player-box"
                        v-if="getAttribute(_course, 'custom-thumb-video') != ''"
                        v-bind:auto-play="getAttribute(_course, 'custom-thumb-video')"
                        v-bind:auto-play-ref="`videoPlayer-${series.prefix}-${index}`"
                        :id="`autoVideoPlayer-${series.prefix}-${index}`"
                        :ref="`autoVideoPlayer-${series.prefix}-${index}`"
                        :options="cloneOptions(getAttribute(_course, 'custom-thumb-video'))"
                        :playsinline="true"
                        @play="onPlayerPlay($event)"
                        @pause="onPlayerPause($event)"
                        @ended="onPlayerEnded($event, true)"
                        @playing="onPlayerPlaying($event)"
                        @canplay="onPlayerCanplay($event, series.prefix, index, 'autoVideoPlayer')"
                        @ready="playerReady">
                      </video-player>
                  </div>
                  <div class="playable-mask-container align-items-center justify-content-center"
                    v-if="getAttribute(_course, 'cover', '') != ''"
                    @mouseover="overVideo(series.prefix, index)">
                    <div class="playable-mask align-items-center justify-content-center">
                      <video-player class="video-player-box"
                        :ref="`videoPlayer-${series.prefix}-${index}`"
                        :options="cloneOptions(getAttribute(_course, 'cover'), false)"
                        :playsinline="true"
                        @play="onPlayerPlay($event)"
                        @pause="onPlayerPause($event)"
                        @ended="onPlayerEnded($event)"
                        @playing="onPlayerPlaying($event)"
                        @canplay="onPlayerCanplay($event, series.prefix, index)"
                        @ready="playerReady">
                      </video-player>
                    </div>
                  </div>
                  <div class="play-container d-flex align-items-center justify-content-center"
                    v-if="checkIsPlayButtonVisible(_course, series.prefix, index)"
                    @mouseleave="leaveVideo(series.prefix, index)">
                    <div class="play" :class="{ 'play-with-cover': getAttribute(_course, 'cover') !== '' }">
                      <font-awesome-icon icon="play" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row control-row">
              <div class="col">
                <div class="control-container">
                  <router-link
                    :xto="{ name: 'Course', params: { series_id: series.id, course_id: _course.id }}"
                    :to="getRouterLink(series, _course)"
                    v-if="_course !== undefined && _course['available'] !== undefined && _course['available'] == true">
                    <div class="title" v-text="_course.title"></div>
                    <div class="sub-title" v-if="getAttribute(_course, 'sub-title') != ''" v-text="getAttribute(_course, 'sub-title')"></div>
                    <button type="button" class="btn btn-info">進入課程</button>
                  </router-link>
                  <div class="not-available"
                    v-if="_course !== undefined && (_course['available'] == undefined || _course['available'] != true)">
                    <div class="title" v-text="_course.title"></div>
                    <div class="sub-title" v-if="getAttribute(_course, 'sub-title') != ''" v-text="getAttribute(_course, 'sub-title')"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sprite-coming-soon_cover" v-if="false && _course === undefined"></div>
          </div>
        </div>
        <div class="series-footer"
          v-if="getAttribute(series, 'footer-block-html') != ''"
          v-html="getAttribute(series, 'footer-block-html')"></div>
        <div :class="getAttribute(series, 'css_class_footer')"></div>
      </div>
    </div>
    <video-js ref="video"></video-js>
  </div>
</template>
<script>
  import _ from 'lodash'
  import $ from 'jquery'
  import Vue from 'vue'
  import {
    mapGetters, mapActions, mapState,
  } from 'vuex'

  import { globalMixin, courseMixin, GuardMixin } from './_Mixins'

  import VideoJS from '@/components/VideoJS'
  //import { watch } from 'fs';

  import utils from '../utils'

  import videojs from 'video.js'
  window.videojs = videojs

  let lang = require('video.js/dist/lang/zh-TW.json')
  videojs.addLanguage('zh-TW', lang)

  //Vue.component('font-awesome-icon', FontAwesomeIcon)
  export default {
    data() {
      return {
        body: document.querySelector('body'),

        overCourseItem: { prefix: '', index: -1 },
        last_prefix: '',
        last_index: 0,
        // last_playitem is an object
        // search this.last_playing
        last_playing: undefined,
        last_ratio: 0,
        waiting_playing: undefined,
        last_timeout: 0,

        playing: false,
        pausing: false,

        full_playing: false,

        seriesesInData: [],

        autoplay_prepare_pool: [],

        playerOptions: {
          // videojs options
          muted: true,
          fluid: true,
          controls: false,
          preload: true,
          language: 'zh-TW',
          autoplay: true,
          // sources: [{
          //   type: "video/mp4",
          //   src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          // }],
          sources: [],
          // poster: "/static/images/author.jpg",
          poster: this.getImageSrc('iconfinder_video-media_512_2.svg')
        },
      }
    },

    // created() {
    //   console.log('SeriesList.vue',
    //     '[router watch]',
    //     'created()')
    // },

    mounted() {
      let _this = this

      // console.log(this.getSerieses)
      //let serieses = this.getSerieses()
      // console.log('SeriesList.vue',
      //   '[router watch]',
      //   'mounted()')

      this.getSerieses()

      // console.log(
      //   '[SeriesList.vue]',
      //   'mounted',
      //   'getSerieses()',
      //   'state.Serieses',
      //   this.Serieses,
      //   this.seriesesInState)

      let detectSeriesIsInViewPort = () => {
        // let serieses = _this.serieses

        // let serieses = this.seriesesInData
        // _this.seriesesInState = await _this.getSerieses()

        // console.log('SeriesList.vue',
        //   'detectSeriesIsInViewPort',
        //   'document.documentElement.scrollTop : ',
        //   document.documentElement.scrollTop)

        let processDetectSeriesIsInViewPort = (serieses) => {
          if (Array.isArray(serieses) == false) return

          serieses.forEach((series) => {

            let series_id = series.id
            let prefix = series.prefix
            let indexes = [1, 2, 3]
            let column = this.getAttribute(series, 'column', 3)
            if (column != 3) {
              indexes = this.createIndexArray(column)
            }

            // console.log('SeriesList.vue',
            //   'detectSeriesIsInViewPort',
            //   'serieses.forEach',
            //   'series : ', series,
            //   'prefix : ', prefix,
            //   'indexes : ', indexes,
            // )

            indexes.forEach((index) => {
              let is_lastplay_same_as_current =
                (this.last_prefix != prefix &&
                  this.last_index != index)

              if (is_lastplay_same_as_current) {
                // let _this = this
                let selector = `.series-${prefix}-${index}`
                _this.isInViewport(document.querySelector(selector), (target) => {
                  let containsPlay =
                    target.attributes['play']

                  if (containsPlay) {
                    containsPlay = target.attributes['play'] != ''
                  }

                  // console.log('SeriesList.vue',
                  //   'InViewport',
                  //   '# check containsPlay',
                  //   target,
                  //   containsPlay)

                  //if (!containsPlay) return

                  // console.log('SeriesList.vue',
                  //   'InViewport',
                  //   `${prefix}.${index} in viewport`,
                  //   ' check containsPlay : ',
                  //   containsPlay)

                  _this.last_prefix = prefix
                  _this.last_index = index

                  // delay to autoplay in muted
                  setTimeout(() => {
                    // visibilityChanged(isVisible, entry, series, index = 1, _this = this)
                    _this.visibilityChanged(containsPlay,
                      {},
                      _this.last_prefix,
                      _this.last_index,
                      _this,
                      series_id)
                  }, 500)
                })
              }
            })
          })
        }
        let checkSeriesesIsPromise = (_serieses) => {
          if (utils.isPromise(_serieses)) {
            _serieses.then((__serieses) => {
              // console.log('SeriesList.vue',
              //   'detectSeriesIsInViewPort',
              //   'Promise for serieses',
              //   'then',
              //   __serieses)
              checkSeriesesIsPromise(__serieses)
            })
          }
          else {
            // console.log('SeriesList.vue',
            //     'detectSeriesIsInViewPort',
            //     'Promise for serieses',
            //     _serieses)
            processDetectSeriesIsInViewPort(_serieses)
          }
        }

        checkSeriesesIsPromise(_this.serieses)
      }

      setTimeout(detectSeriesIsInViewPort, 500)

      //window.addEventListener('scroll', detectSeriesIsInViewPort)
      $(window).scroll(detectSeriesIsInViewPort)
    },

    // updated() {
    //   console.log('SeriesList.vue',
    //     '[router watch]',
    //     'updated()')
    // },
    // updated() {
    //   //console.log('updated')
    //   let _this = this

    //   let bindAutoPlay = function(selector = '.video-player-box[auto-play]') {
    //     $(selector).each(function(index, element) {
    //       var $el = $(element)
    //       var autoPlay = $el.attr('auto-play')
    //       var binding = $el.attr('auto-play-binding') || '' == 'yes'

    //       // console.log('>>> SeriesList.vue', 'bindAutoPlay...', $el, autoPlay, binding)

    //       // if (!binding && autoPlay && autoPlay != '') {
    //       //   $el.attr('auto-play-binding', 'yes')

    //       //   let ref = $el.attr('auto-play-ref')

    //       //   // console.log('>>> SeriesList.vue', 'bindAutoPlay...', 'ref', ref)

    //       //   // var ref = $el.attr('auto-play-ref')

    //       //   // _this.autoplayVideo(ref, autoPlay)
    //       //   // console.log('SeriesList.vue', 'auto-play', 'this.$refs[ref].options : ', _this.$refs[ref].player['options'])
    //       // }
    //     })
    //   }

    //   $(function() {
    //     setTimeout(function() { bindAutoPlay() }, 500)
    //   })
    // },

    components: {
      'video-js': VideoJS,
    },

    methods: {
      detectRouteHash () {
        let _this = this
        if (this.serieses.length == 0) {
          setTimeout(this.detectRouteHash, 200)
          return
        }

        setTimeout(function() {
          // console.log('SeriesList.vue',
          //   'detectRouteHash',
          //   'called !',
          //   _this.serieses,
          //   _this.$route)
          if (_this.$route && _this.$route['hash'] != '') {
            _this.scrollToHash(_this.$route)
          }
          // _this.scrollToHash(_this.$route)
        })
      },

      cloneOptions(src, autoPlay = true) {
        let _options = _.cloneWith(this.playerOptions)
        // _options.sources = src
        // _options.autoplay = true
        let mergeOption = {
          sources: src,
          autoplay: autoPlay,
        }
        _options = { ..._options, ...mergeOption }

        return _options
      },

      createIndexArray(arraySize) {
        let array = new Array(arraySize)
        for (let i = 1; i <= arraySize; i++) {
          array[i - 1] = i
        }

        return array
      },

      visibilityChanged(isVisible, entry, series, index = 1, _this = this, series_id = -1) {
        console.log('SeriesList.vue', 'visibilityChanged',
          'series :', series, 'index :', index, 'series_id :', series_id)

        let watchPropertyAvailable = (obj, property, callback, current_times = 0, max_times = 30) => {
          let next = () => {
            setTimeout(() => {
              watchPropertyAvailable(obj, property, callback, current_times + 1, max_times)
            }, 100)
          }

          if (current_times > max_times) return

          if (obj == undefined) {
            next()
            return
          }

          if (typeof(obj[property]) != 'string') {
            next()
            return
          }

          if (obj[property] && callback) {
            callback(obj[property])
            return
          }

          next()
        }

        let _visibilityChanged = (_this, index = 1, series_id = -1) => {
          // console.log('SeriesList.vue',
          //   'check video.js autoplay',
          //   ' @@ isVisible : ',
          //   isVisible,
          //   ' @@ this.full_playing : ',
          //   this.full_playing)

          if (isVisible == false) return
          if (_this.full_playing) return

          // watchPropertyAvailable(course, 'cover', (src) => {
          //   console.log('SeriesList.vue',
          //     'entry',
          //     entry,
          //     entry.intersectionRatio,
          //     series,
          //     index,
          //     src)
          // })
          // return

          let refName = `cover-player-${series}-${index}`
          let ref = _this.$refs[refName]
          // console.log('SeriesList.vue',
          //   ' check ref : ',
          //   ref !== undefined)

          if (ref) {

            // let ref = this.$refs[refName]
            if (Array.isArray(ref) == false) return

            if (!ref[0]) return

            let _play = ref[0].attributes['play']

            // console.log('SeriesList.vue',
            //   'ref',
            //   series,
            //   ref,
            //   _play,
            //   _play.value == '')

            if (_play.value == '') {
              //console.log('return function', 'refName :', refName);
              return
            }

            // console.log('SeriesList',
            //   'visibilityChanged',
            //   '_play.value',
            //   _play.value,
            //   'series_id :',
            //   series_id)

          // if (entry.target.attributes['play'] ) {
            // let series = entry.target.attributes['series']['value']
            // let index = entry.target.attributes['index']['value']

            // let play = entry.target.attributes['play']['value']

            let playSource = _play.value

            // console.log('SeriesList.vue',
            //   ' # playSource check : ',
            //   playSource,
            //   ' playSource && playSource.length > 0 : ',
            //   playSource && playSource.length > 0)

            if (playSource && playSource.length > 0) {
              // console.log('SeriesList.vue',
              //   ' @@entry ',
              //   entry,
              //   entry.intersectionRatio,
              //   series,
              //   index,
              //   playSource)
              // return

              let src = _this.combineFullResourceUrl(playSource, true, series_id)

              // console.log('SeriesList.vue',
              //   'isVisible : ',
              //   isVisible,
              //   entry.target,
              //   entry.target.attributes['play'], play,
              //   playSource,
              //   src)

              if (isVisible) {
                //console.log('SeriesList.vue', 'visibilityChanged', 'src :', src)
                // console.log('SeriesList.vue',
                //   'autoPlay',
                //   ' @@ check src : ',
                //   src)
                // if (entry.intersectionRatio >= this.last_ratio) {
                //  this.last_ratio = entry.intersectionRatio
                if (_this.waiting_playing === undefined) {
                  _this.waiting_playing = []
                }
                _this.waiting_playing.push({
                  series: series,
                  index: index,
                  src: src
                })
                // }

                if (_this.last_timeout > 0) {
                  clearTimeout(_this.last_timeout)
                }

                // let _this = this
                _this.last_timeout = setTimeout(() => {
                  // console.log('SeriesList.vue',
                  //   'ready to play',
                  //   _this.waiting_playing)
                  // return

                  _this.waiting_playing.forEach((item) => {
                    item = utils.getObserveValue(item)
                    // console.log('SeriesList.vue', 'waiting_playing.forEach',
                    //   'index :', index,
                    //   'item :', item)

                    let series = item.series
                    let index = item.index

                    let playerRef = _this.$refs[`cover-player-${series}-${index}`]

                    let play_src = item.src

                    // just for test if video source is from https
                    // will be solve autoplay not working on iOS?
                    // play_src = 'https://vjs.zencdn.net/v/oceans.mp4'

                    if (_this.last_playing != undefined) {
                      let last_series = _this.last_playing.series
                      let last_index = _this.last_playing.index

                      if (last_series == series && last_index == index) return

                      let last_player =
                        _this.$refs[`videoPlayer-${last_series}-${last_index}`].player

                      // console.log('SeriesList.vue',
                      //   '# check last_player',
                      //   last_player)
                    }

                    // // DONE: 要把 isPromise 移成公用函數
                    // var isPromise = function(object) {
                    //     if(Promise && Promise.resolve){
                    //       return Promise.resolve(object) == object;
                    //     }
                    //     else {
                    //       throw "Promise not supported in your environment"
                    //     }
                    // }

                    _this.last_playing = {
                      series: series,
                      index: index,
                      ref: `videoPlayer-${series}-${index}`,
                      src: play_src,
                      state: '',
                    }

                    // console.log('SeriesList.vue',
                    //   '# check play_src : ',
                    //   play_src,
                    //   '# check this.last_playing : ',
                    //   _this.last_playing)

                    // console.warn(play_src)

                    // _this.playerOptions.sources = [{
                    //   type: 'video/mp4',
                    //   src: play_src
                    // }]

                    if (utils.isPromise(play_src)) {
                      play_src.then(function(data) {
                        //_this.play_source = play_src
                        _this.play_source = data
                      })
                    }
                    else {
                      _this.play_source = play_src
                    }

                    // console.log('SeriesList.vue',
                    //   ' # play_source check : ',
                    //   _this.play_source,
                    //   ' # play_src : ',
                    //   play_src)
                  })
                }, 1000)
              }
            }
          }

          // watchPropertyAvailable(entry.target, 'play', (play) => {
          //   console.log('SeriesList.vue', isVisible, entry.target, entry.target.attributes)
          // }, 0, 30)
        }

        for (let i = 1; i < 10; i++) {
          _visibilityChanged(_this, i, series_id)
        }
      },

      getRouterLink(series, course) {
        if (series == undefined) return '/'
        if (course == undefined) return '/'

        if (this.getAttribute(course, 'available') == true) {
          let link = this.getAttribute(course, 'link')

          if (link != '') {
            return link
          }

          return {
            "name": "Course",
            "params": {
              "series_id": series.id,
              "course_id": course.id
            }
          }
        }

        return ''
      },

      // autoplayVideo(ref, autoPlay) {
      //   let _this = this
      //   let $refs = this.$refs[ref]

      //   // console.log('SeriesList.vue', 'autoplayVideo', '$refs : 1', $refs)

      //   if (Array.isArray($refs)) {
      //     $refs = $refs[0]
      //   }

      //   if ($refs && $refs.options) {
      //     // let options = _.cloneDeep(_this.playerOptions) // $refs.options
      //     // $refs.options = options

      //     // console.log('SeriesList.vue', 'autoplayVideo', '$refs : 2', ref, autoPlay, $refs, $refs.options)

      //     // $refs.options.sources = [{
      //     //   type: 'video/mp4',
      //     //   src: autoPlay,
      //     // }]
      //   }
      // },

      overVideo(series_prefix, index) {
        if (this.last_prefix == series_prefix && this.last_index == index) {
          if (this.is_playing) {
            this.pausing = true

            this.overCourseItem = {
              prefix: series_prefix,
              index: index,
            }

            console.log('SeriesList.vue',
              'overVideo')
          }
        }
      },

      leaveVideo(series_prefix, index) {

        if (this.pausing && this.checkIsPausing(series_prefix, index)) {

          this.pausing = false
          this.overCourseItem = {
            prefix: '',
            index: -1
          }

          this.current_play_video.autoplay('muted')
        }
      },

      playVideo(series, course) {
        // pause video preview first
        this.full_playing = true

        let series_id = series.id

        console.log('SeriesList.vue', 'playVideo', series_id)
        let src = this.combineFullResourceUrl(course.cover)

        this.$refs.video.play(src)
      },

      checkIndexAvailable(series, index) {
        if (!series) return false

        if (!series.courses) return false

        return series.courses.length > --index
      },

      getCourseByIndexInSeries(series, index) {
        if (this.checkIndexAvailable(series, index) == false) {
          return undefined
        }

        return series.courses[--index]
      },

      checkCourseIsAvailable(course) {
        if (!course) return false
        if (course === undefined) return false
        if (course == null) return false
        if (!course['title']) return false

        if (!course['available']) return true

        console.log('checkCourseIsAvailable', course.available)

        return course.available
      },

      checkIsPlayButtonVisible(course, prefix, index) {

        if (course == undefined) return false
        //let available = this.getAttribute(course, 'available')

        //if (available == false) return false

        let cover = this.getAttribute(course, 'cover')

        if (cover == '') return false

        return true
      },

      checkIsHover(prefix, index) {
        if (this.overCourseItem !== undefined) {
          if (this.overCourseItem.prefix == prefix &&
            this.overCourseItem.index == index) {
              // console.log('SeriesList.vue',
              //   ' watch this.current_play_video : ',
              //   this.current_play_video)

              // pause play
              if (this.current_play_video) {
                this.current_play_video.pause()
              }

              // show play button
              return true
            }
        }

        return false
      },

      checkIsPausing(prefix, index) {
        if (this.last_playing == undefined) return false
        if (this.overCourseItem == undefined) return false

        console.log('SeriesList.vue',
          ' @checkIsPausing ',
          ' watch this.overCourseItem : ',
          this.overCourseItem)

        if (this.overCourseItem.prefix = prefix &&
          this.overCourseItem.index == index) {
            return this.pausing
          }

        return false
      },

      checkIsPlaying(prefix, index) {
        // console.log('SeriesList.vue',
        //   'checkIsPlaying',
        //   this.last_playing,
        //   prefix,
        //   index)
        if (this.last_playing == undefined) return false

        let isPlayingCurrentItem =
          (this.last_playing.series == prefix &&
            this.last_playing.index == index)
        // if (!isPlaying) return false

        // return this.is_playing == true
        return isPlayingCurrentItem
      },

      onPlayerPlay(player) {
        // console.log('SeriesList.vue', 'player play!', player)
      },

      onPlayerPause(player) {
        // console.log('SeriesList.vue', 'player pause!', player)
        this.playing = false
      },

      onPlayerEnded(player, repeatPlay = false) {
        // console.log('SeriesList.vue', 'player ended', player)

        //this.closePlayer()
        this.playing = false
        if (repeatPlay) {
          player.autoplay('muted')
        }
      },

      onPlayerPlaying(player) {
        console.log('SeriesList.vue',
          'player playing',
          player)

        this.playing = true
      },

      onPlayerCanplay(player, binding_series, binding_index, ref_prefix = 'videoPlayer') {
        // console.log('SeriesList.vue',
        //   'onPlayerCanplay',
        //   ref_prefix)

        // let $ref = this.$refs[`videoPlayer-${series}-${index}`]
        // let isAutoPlay = ref_prefix.indexOf('autoVideoPlayer') != -1
        let isAutoPlay = false
        let $ref = `${ref_prefix}-${binding_series}-${binding_index}`

        let series = binding_series, index = binding_index

        // if (isAutoPlay) {
        //   console.log('SeriesList.vue',
        //     'onPlayerCanplay',
        //     'isAutoPlay',
        //     player,
        //     binding_series,
        //     binding_index,
        //     $ref,
        //     isAutoPlay)

        //   series = binding_series
        //   index = binding_index

        //   // console.log('>>> SeriesList.vue', 'onPlayerCanplay', '$ref', $ref)
        //   this.autoplay_prepare_pool.push({
        //     ref: `videoPlayer-${series}-${$index}`,
        //     series: series,
        //     index: index,
        //   })
        // }
        // else if (this.last_playing) {
        //   series = this.last_playing.series
        //   index = this.last_playing.index
        // }
        if (this.last_playing) {
          series = this.last_playing.series
          index = this.last_playing.index
        }

        // if (ref_prefix.indexOf('autoplay') != -1) {
        //   this.last_playing = {
        //     series: binding_series,
        //     index: binding_index,
        //   }
        // }

        // if (isAutoPlay || (binding_series == series && binding_index == index)) {
        //   let refName = `${ref_prefix}-${series}-${index}`

        //   let refVideoPlayer = this.$refs[refName]

        //   // console.log('SeriesList.vue',
        //   //   'onPlayerCanplay',
        //   //   '_player',
        //   //   refName,
        //   //   refVideoPlayer)

        //   if (refVideoPlayer && refVideoPlayer[0]) {
        //     // DONE: auto play here
        //     let _player = refVideoPlayer[0].player
        //     // this.playing = true

        //     console.log('SeriesList.vue',
        //       'onPlayerCanplay',
        //       'refVideoPlayer',
        //       series,
        //       index,
        //       _player,
        //       _player.autoplay,
        //       refVideoPlayer[0].player,
        //       player.autoplay)

        //     _player.autoplay('muted')
        //     // setTimeout(() => {
        //     //   console.log('SeriesList.vue',
        //     //     'do autoplay',
        //     //     _player,
        //     //     _player.autoplay
        //     //     )


        //     // }, 200)
        //   }
        // }
      },

      playerReady($event) {

        // let player = $event.player()
        // let _el = $event.el()
        // let $_el = $(_el)
        // let id = $_el.attr('id')
        // let $el = $_el.parent()

        // var autoPlay = $el.attr('auto-play')
        // var binding = $el.attr('auto-play-binding') || '' == 'yes'

        // if (!binding && autoPlay && autoPlay != '') {
        //   $el.attr('auto-play-binding', 'yes')

        //   let ref = $el.attr('auto-play-ref')

        //   let checkIsAutoPlaying = function(ref) {
        //     let index =
        //       _.findIndex(_this.autoplay_prepare_pool,
        //         { ref: ref })
        //     if (index == -1) {

        //     }
        //   }
        //   setTimeout(function() {
        //     // is in auto-play poll checking
        //     console.log('>>> SeriesList.vue',
        //       'playerReady',
        //       'ref',
        //       ref,
        //       'player.networkState',
        //       player.networkState(),
        //       'player.readyState',
        //       player.readyState())
        //   }, 10 * 1000)
        // }

        // console.log('>>> SeriesList.vue',
        //   'player ready',
        //   '$event : ',
        //   $el,
        //   id,
        //   autoPlay,
        //   binding,
        //   player,
        //   player.src())
      }
    },

    mixins: [ globalMixin, courseMixin, GuardMixin ],

    // asyncComputed: {
    //   ...mapState([ 'seriesesInState' ]),

    //   serieses: {
    //     get () {
    //       //console.log('SeriesList.vue', 'asyncComputed', 'serieses', 'seriesesInState', this.seriesesInState)

    //       return new Promise(resolve => {
    //         //console.log('SeriesList.vue > computed > seriesesInState : ', this.seriesesInState)
    //         if (this.seriesesInData.length > 0) {
    //           return this.prepareSerieses(this.seriesesInState)
    //         }

    //         // let _this = this
    //         // this.getSerieses(function(_serieses) {
    //         //   this.prepareSerieses(_serieses)
    //         // })

    //         // let serieses = await this.getSerieses()
    //         //console.log('SeriesList.vue', 'computed', 'async serieses : ', serieses)
    //         this.getSerieses(function(serieses) {
    //           this.seriesesInData = this.prepareSerieses(serieses)

    //           resolve(this.seriesesInData)
    //         })
    //       })
    //     },
    //     default() {
    //       return []
    //     }
    //   }
    // },

    computed: {
      ...mapState([ 'seriesesInState', 'seriesesFilesLoading' ]),
      ...mapGetters([ 'Serieses' ]),

      serieses() {
        let _serieses = this.Serieses

        return this.prepareSerieses(_serieses)
      },

      is_playing() {
        return this.playing
      },

      player_options() {
        return this.playerOptions
      },

      play_source: {
        get: function() {
          return this.playerOptions.sources
        },

        set: function(value) {
          // console.log('SeriesList.vue > play_source : ', value)

          // this.playerOptions.sources = [{
          //   type: 'video/mp4',
          //   src: value,
          // }]
          let _options = this.cloneOptions(value)
          this.playerOptions = _options
        }
      },

      current_play_video() {
        if (this.last_playing == undefined) return

        let series = this.last_playing.series
        let index = this.last_playing.index

        let refName = `videoPlayer-${series}-${index}`
        let refVideoPlayer = this.$refs[refName]

        if (refVideoPlayer && refVideoPlayer[0]) {
          let _player = refVideoPlayer[0].player

          return _player
        }
      },
    },

    watch: {
      'serieses': function (newValue) {
        // console.log('#1090 watch serieses',
        //   newValue)
      },

      'seriesesInState': function (newValue) {
        // console.log('SeriesList.vue',
        //   'watch',
        //   'seriesesInState : ',
        //   newValue)
      },

      'seriesesFilesLoading': function (newValue) {
        // console.log('SeriesList.vue',
        //   'watch',
        //   'seriesesFilesLoading',
        //   newValue)
        if (newValue == false) {
          setTimeout(this.detectRouteHash, 500)
        }
      },

      'is_playing': function (newValue, oldValue) {
        // TODO : mouseover event should be trigger is_playing changed
        // console.log('SeriesList.vue',
        //   'watch: is_playing',
        //   ' this.last_playing : ',
        //   this.last_playing,
        //   !this.last_playing)

        if (!this.last_playing) return

        // console.log('SeriesList.vue',
        //   'Vue.watch for "is_playing"',
        //   ' @before ',
        //   ' oldValue : ',
        //   oldValue,
        //   ' newValue : ',
        //   newValue,
        //   ' this.last_playing : ',
        //   this.last_playing)

        // console.log('SeriesList.vue',
        //   'Vue.watch for "is_playing"',
        //   ' @after ',
        //   ' _player : ',
        //   _player)

        let _player = this.current_play_video
        if (_player) {
          if (oldValue == true && newValue == false) {
            // pause
            _player.pause()
          }
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/SeriesList.vue